module.exports = __webpack_public_path__ + "img/emoji_inactive.db14d2ac.svg";